module.exports = __webpack_public_path__ + "img/jon_smith_1.670b1a7f.png";